import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=0ad5c56a&scoped=true&lang=pug&"
import script from "./VisitsTable.vue?vue&type=script&lang=js&"
export * from "./VisitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5c56a",
  null
  
)

export default component.exports